module.exports = __webpack_public_path__ + "static/7-7f6e7a7b63ec30e227ca7533a2f14d07.jpg";